<template>
  <div id="searchCEPModal" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Buscar CEP</h5>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label" for="uf">UF</label>
            <select
              v-model="state"
              :disabled="cepFound"
              aria-label="Selecione a UF"
              class="form-select"
              name="UF"
              @change="attCounties()"
            >
              <option selected value="">Selecione um estado</option>
              <option v-for="state in states" :key="state" :value="state.value">
                {{ state.text }}
              </option>
            </select>
          </div>

          <div class="mb-3">
            <label class="form-label" for="municipio">Município</label>
            <select
              v-model="county"
              :disabled="!stateSelected"
              aria-label="Selecione o município"
              class="form-select"
              name="county"
            >
              <option selected value="">Selecione um município</option>
              <option v-for="county in counties" :key="county" :value="county">
                {{ county }}
              </option>
            </select>
          </div>

          <div class="mb-3">
            <label class="form-label" for="endereco">Endereço</label>
            <input
              id="endereco"
              v-model="address"
              class="form-control"
              name="endereco"
              placeholder="Digite aqui o seu endereço"
              type="text"
            />
          </div>
        </div>
        <div class="button-container">
          <button aria-label="Close" class="btn-cancel" data-bs-dismiss="modal">
            Fechar
          </button>
          <button
            id="search-button"
            :disabled="state === '' || county === '' || address === ''"
            class="btn-search"
            type="button"
            @click="searchForCEP"
          >
            Buscar
          </button>
        </div>
        <div
          :class="{ 'on-search': dataFound != undefined }"
          class="modal-footer"
        >
          <table v-if="dataFound === true" class="table w-100">
            <thead>
              <tr>
                <th scope="col">UF</th>
                <th scope="col">Município</th>
                <th scope="col">Log.</th>
                <th scope="col">Bairro</th>
                <th scope="col">CEP</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in results" :key="data">
                <td>{{ data.uf }}</td>
                <td>{{ data.localidade }}</td>
                <td>{{ data.logradouro }}</td>
                <td>{{ data.bairro }}</td>
                <td>
                  <a data-bs-dismiss="modal" href="" @click="useCEP">
                    <span style="margin-right: 0.5em"> {{ data.cep }} </span>
                    <i class="fa-regular fa-clipboard"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>

          <p v-if="dataFound === false" id="no-results" class="text-center">
            Nenhum resultado encontrado
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import municipios from "../../assets/json/estados_municipios.json";

export default {
  name: "CEPModal",
  data() {
    return {
      dataFound: undefined,
      results: [],

      stateSelected: false,
      state: "",
      county: "",
      address: "",

      municipios,
      states: [
        { value: "AC", text: "Acre" },
        { value: "AL", text: "Alagoas" },
        { value: "AP", text: "Amapá" },
        { value: "AM", text: "Amazonas" },
        { value: "BA", text: "Bahia" },
        { value: "CE", text: "Ceará" },
        { value: "DF", text: "Distrito Federal" },
        { value: "ES", text: "Espírito Santo" },
        { value: "GO", text: "Goiás" },
        { value: "MA", text: "Maranhão" },
        { value: "MT", text: "Mato Grosso" },
        { value: "MS", text: "Mato Grosso do Sul" },
        { value: "MG", text: "Minas Gerais" },
        { value: "PA", text: "Pará" },
        { value: "PB", text: "Paraíba" },
        { value: "PR", text: "Paraná" },
        { value: "PE", text: "Pernambuco" },
        { value: "PI", text: "Piauí" },
        { value: "RJ", text: "Rio de Janeiro" },
        { value: "RN", text: "Rio Grande do Norte" },
        { value: "RS", text: "Rio Grande do Sul" },
        { value: "RO", text: "Rondônia" },
        { value: "RR", text: "Roraima" },
        { value: "SC", text: "Santa Catarina" },
        { value: "SP", text: "São Paulo" },
        { value: "SE", text: "Sergipe" },
        { value: "TO", text: "Tocantins" },
      ],
    };
  },
  methods: {
    attCounties() {
      try {
        // Muda a lista de cidades dentro do input select com base no estado que foi selecionado
        this.counties = municipios[this.state].cidades;
      } catch (exception) {
        this.stateSelected = false;
        this.state = "";
      }

      // Habilita/desabilita o input select no qual as cidades serão selecionadas
      if (this.state === "") {
        this.stateSelected = false;
        this.county = "";
      } else {
        this.stateSelected = true;
        this.county = "";
      }
    },

    async searchForCEP() {
      let response = null;
      let data = null;

      // Verifica se não há nenhum campo vazio
      if (this.state === "" || this.county === "" || this.address === "") {
        this.dataFound = false;
        return;
      }

      try {
        response = await fetch(
          "https://viacep.com.br/ws/" +
            this.state +
            "/" +
            this.county +
            "/" +
            this.address +
            "/json/"
        );
        data = await response.json();

        // Verifica se o array que armazena os resultados tem tamanho igual a zero, caso não tiver atribui os dados à variávle de resultados e habilita a tabela
        if (data.length === 0) {
          this.dataFound = false;
        } else {
          this.dataFound = true;
          this.results = data;
        }
      } catch (e) {
        this.dataFound = false;
      }
    },

    useCEP(event) {
      let cep = event.target.innerText;

      // Evita que o usuário seja redirecionado para o href do link
      event.preventDefault();

      // Chama a função que busca os dados do CEP
      this.$parent.getDataForCEP(cep);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");

#no-results {
  margin-top: 1rem;
}

/* ESTILIZAÇÃO DO MODAL */

h5 {
  color: #004a8a;
}

.modal-content {
  border-radius: 10px;
  padding: 2rem;
}

.modal-header {
  border-bottom: none;
}

.modal-header,
.modal-body,
.modal-footer {
  padding: 0;
}

.modal-body {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.modal-footer {
  border-top: none;
  justify-content: center;
}

.on-search {
  margin-top: 1rem;
  border-top: 1px solid #e5e5e5;
}

/* ESTILIZAÇÃO DO BOTÃO */

.button-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

button {
  width: 45%;
  padding: 1em 2em;
  border-radius: 10px;
  border: none;
  color: white;
  background-color: #004a8a;
  font-weight: bold;
}

button:not([disabled]):hover {
  background-color: #5aad31;
  cursor: pointer;
}

button:disabled {
  background-color: #e0e0e0;
}

button.btn-cancel {
  background-color: #828282;
}

/* ESTILIZAÇÃO DA TABELA */

td:first-child,
th:first-child {
  border-radius: 10px 0 0 10px;
}

td:last-child,
th:last-child {
  border-radius: 0 10px 10px 0;
}

thead {
  background-color: #004a8a;
  color: #fff;
}

th:nth-child(1),
td:nth-child(1) {
  text-indent: 1em;
}

td:last-child {
  font-weight: bold;
}

tbody {
  background-color: #e0e0e0;
}

.table {
  border-spacing: 0 15px;
  border-collapse: separate;
  border-spacing: 0 16px;
}

th,
td {
  text-align: center;
  padding: 1em 0;
  border-style: unset;
  vertical-align: middle;
}

/* ESTILIZAÇÃO DAS LABELS E INPUTS */

label.form-label {
  color: rgb(130, 130, 130);
}

input[type="text"],
input[type="date"],
select {
  border-radius: 10px;
  border-color: #282828;
  padding: 0.875em 1.5em;
}

@media (max-width: 576px) {
  button {
    width: 100%;
  }

  .button-container {
    align-items: center;
    flex-direction: column-reverse;
  }

  .btn-cancel {
    margin-top: 0.5em;
  }
}
</style>
